<template>
	<div class="tips">
		<div class="tips_block">
			<img class="tips_block_1" src="../resource/tips.png" alt="" />
			<div class="tips_block_2">温馨提示</div>
			<div class="tips_block_3">请前往-【云闪付APP】-【权益精选】-【品质生活】-【星级酒店SPA礼遇】进行权益支付预约，谢谢您的理解!</div>
		</div>
	</div>
</template>
<script>
	
	export default {
		data() {
			return {
				
			}
		},
		mounted() {
			
			
		},
		methods: {
			
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.tips{
		width: 100%;
		height: 100vh;
		overflow: hidden;
		background-color: #F9F9F9;
	}
	.tips_block{
		width: 100%;
		padding: 100*@vm_base 40*@vm_base 125*@vm_base 40*@vm_base;
		background: linear-gradient( 180deg, rgba(247,127,40,0.1) 0%, rgba(247,127,40,0) 100%);
		text-align: center;
	}
	.tips_block_1{
		width: 260*@vm_base;
		margin: 0 auto;
	}
	.tips_block_2{
		width: 100%;
		text-align: center;
		font-size: 32*@vm_base;
		color: #333333;
		padding: 60*@vm_base 0 40*@vm_base;
	}
	.tips_block_3{
		width: 100%;
		font-size: 30*@vm_base;
		color: #666666;
		line-height: 1.5;
		letter-spacing: 1*@vm_base;
		text-align: left;
	}
</style>


// WEBPACK FOOTER //
// src/views/tips.vue